module.exports = __webpack_public_path__ + "static/media/right-1.cd3e8cf3.jpg";